/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-08-26 15:09:16
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-20 14:34:31
 */
import { PLATFORM_DY, PLATFORM_KS, PLATFORM_SP, PLATFORM_LIST, tzRoleType, cgRoleType, zsRoleType, drRoleType } from '@/utils/dataMap';
// import { DICT_TYPE, getDictDataLabel2 } from '@/utils/dict';
export default {
	// 是否是管理员或超管
	isBoss(state) {
		return state.vuex_permissionInfo?.user?.userTypes?.some(item => [tzRoleType.id, cgRoleType.id].includes(+item.type));
	},
	// 是否是招商或超管
	isSallerPatner(state) {
		return state.vuex_permissionInfo?.user?.userTypes?.some(item => [zsRoleType.id].includes(+item.type));
	},
	// 是否是达人运营或超管
	isDarenPartner(state) {
		return state.vuex_permissionInfo?.user?.userTypes?.some(item => [drRoleType.id].includes(+item.type));
	},
	// 账号信息
	accountInfo(state) {
		return state.vuex_permissionInfo?.user || {};
	},
	// 账号权限
	accountPermissions(state) {
		return state.vuex_permissionInfo?.permissions || [];
	},
	// 账号角色
	accountRoles(state) {
		return state.vuex_roles || [];
	},
	// 租户信息
	tenantInfo(state) {
		return state.vuex_permissionInfo?.tenant || {};
	},
	// // 是否是试用账号
	// isTrialAccount(state) {
	// 	return state.vuex_permissionInfo?.tenant?.type === +getDictDataLabel2(DICT_TYPE.SYSTEM_TENANT_TYPE, '试用');
	// },
	// 账号购买的平台版本
	platformVersion(state) {
		return state?.vuex_teamConfig?.platform_list || [];
	},
	// 默认展示的平台版本
	defaultPlatform(state) {
		const [platform_id] = state?.vuex_teamConfig?.platform_list || [];
		return +platform_id;
	},
	// 是否只购买了抖音版本
	onlyDyVersion(state) {
		const [platform_id] = state?.vuex_teamConfig?.platform_list || [];
		const { length } = state?.vuex_teamConfig?.platform_list || [];
		return length === 1 && +platform_id === +PLATFORM_DY.value;
	},
	// 是否只购买了快手版本
	onlyKsVersion(state) {
		const [platform_id] = state?.vuex_teamConfig?.platform_list || [];
		const { length } = state?.vuex_teamConfig?.platform_list || [];
		return length === 1 && +platform_id === +PLATFORM_KS.value;
	},
	// 是否只购买了视频号版本
	onlySpVersion(state) {
		const [platform_id] = state?.vuex_teamConfig?.platform_list || [];
		const { length } = state?.vuex_teamConfig?.platform_list || [];
		return length === 1 && +platform_id === +PLATFORM_SP.value;
	},
	// 非单版本
	notSingleVersion(state) {
		const { length } = state?.vuex_teamConfig?.platform_list || [];
		return length > 1;
	},
	// 可展示的平台
	canShowPlatformList(state) {
		const platformVersion = state?.vuex_teamConfig?.platform_list || [];
		return PLATFORM_LIST.filter(item => platformVersion?.includes(+item.value));
	},
	// 是否是单平台
	isSingleVersion(state) {
		return state?.vuex_teamConfig?.platform_list?.length === 1;
	},
	// 是否是试用账号
	isTrialAccount(state) {
		return state.vuex_userInfo?.account_type === 1;
	},
	// 字典数据
	dict_datas: state => state?.vuex_dictDatas,
};
